export const MAX_QUEUE_SIZE = 10;

export const COLUMN_WIDTHS = {
  sale_date: 150,
  property: 300,
  upset_value: 150,
  downpayment: 200,
  zillow_estimate: 200,
  profit: 150
};

export const PAGINATION_OPTIONS = [10, 20, 50, 100];

export const DEFAULT_SORT_CONFIG = { 
  key: 'profit', 
  direction: 'desc' 
};

export const MONTH_NAMES = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

export const PROFIT_THRESHOLDS = {
  EXCELLENT: 50000,
  GOOD: 25000,
  FAIR: 0
};

export const REQUEST_DELAYS = {
  NORMAL: 1100,
  RATE_LIMIT: 2000
};

export const CHART_COLORS = {
  PRIMARY: '#4f46e5',
  BACKGROUND: '#f8fafc',
  AXIS: '#94a3b8',
  LABEL: '#64748b'
};